import i18nMixin from '@/mixins/i18n.mixin.js';

let monTargetMixin = {
  mixins: [i18nMixin],
  data() {
    return {
      infoFilter: {
        type: false,
        diskSize: false,
        storageInfo: false,
        osInfo: false,
        productIpAddress: false,
        dbVersion: false,
        gpuClusterName: false,
        protocol: false,
        size: false,
        svcCount: false,
        vpcName: false,
        subnetName: false,
        nodeCount: false,
        maxNodeCount: false,
        lbServiceIp: false,
        lbName: false,
        layerType: false,
        esType: false,
        clusterName: false,
        haType: false,
        saType: false,
        productServiceDomain: false,
        serviceDomain: false,
        connectedVPC: false,
        dstTgwName: false,
        drUseYn: false,
        accessControlYn: false,
        hpcNodeCount: false,
        podCount: false,
        resourceName: false,
        logging: false,
        endpointType: false,
        endpoint: false,
        vpnGatewayName: false,
        localTunnelIp: false,
        peerTunnelIp: false,
        peerVpnGatewayIp: false,
        remoteSubnet: false,
        serviceInfo: false,
        webInfo: false,
        execInfo: false,
        queryEngineType: false,
        autoscaling: false,
        maxQuery: false,
        clusSizeCpu: false,
        clusSizeMem: false,
        attachmentType: false,
        segmentName: false,
        accessLocation: false,
        networkName: false,
        productState: false,
        regionZone: false,
        sparkTotalCore: false,
        sparkTotalMemory: false,
        isIGW: false
      },
      labelField: {
        monTarget: this.$t('searchLabel.monitoring_target'),
        target: this.$t('searchLabel.monTarget'),
        productType: this.$t('searchLabel.productType'),
        tagInfo: this.$t('searchLabel.tagInfo'),
        productInfo: this.$t('searchLabel.productInfo'),
        diskQuota: this.$t('searchLabel.diskQuota'),
        storageInfo: this.$t('searchLabel.diskQuota'),
        osInfo: this.$t('searchLabel.osInfo'),
        ip: this.$t('searchLabel.ip'),
        serverType: this.$t('searchLabel.serverType'),
        diskType: this.$t('searchLabel.diskType'),
        dbVersion: this.$t('searchLabel.dbVersion'),
        gpuClusterName: this.$t('searchLabel.gpuClusterName'),
        productServiceDomain: this.$t('searchLabel.productServiceDomain'),
        protocol: this.$t('searchLabel.protocol'),
        size: this.$t('searchLabel.size'),
        svcCount: this.$t('searchLabel.svcCount'),
        vpcName: this.$t('searchLabel.vpcName'),
        subnetName: this.$t('searchLabel.subnetName'),
        nodeCount: this.$t('searchLabel.nodeCount'),
        maxNodeCount: this.$t('searchLabel.maxNodeCount'),
        maxNodeNumber: this.$t('searchLabel.maxNodeNumber'),
        lbServiceIp: this.$t('searchLabel.serviceIp'),
        lbName: this.$t('searchLabel.lbName'),
        lbSize: this.$t('searchLabel.lbSize'),
        layerType: this.$t('searchLabel.layerType'),
        esType: this.$t('searchLabel.esType'),
        clusterName: this.$t('searchLabel.clusterName'),
        dataType: this.$t('searchLabel.dataType'),
        haType: this.$t('searchLabel.haType'),
        saType: this.$t('searchLabel.saType'),
        lbServiceName: this.$t('searchLabel.serviceName'),
        internetConnection: this.$t('searchLabel.internetConnection'),
        vpcPeering: this.$t('searchLabel.vpcPeering'),
        connectedVPC: this.$t('searchLabel.connectedVPC'),
        dstTgwName: this.$t('searchLabel.dstTgwName'),
        drUseYn: this.$t('searchLabel.drUseYn'),
        accessControlYn: this.$t('searchLabel.accessControlYn'),
        useY: this.$t('searchLabel.useY'),
        useN: this.$t('searchLabel.useN'),
        hpcNodeCount: this.$t('searchLabel.hpcNodeCount'),
        podCount: this.$t('searchLabel.podCount'),
        resourceName: this.$t('searchLabel.resourceName'),
        logging: this.$t('searchLabel.logging'),
        endpointType: this.$t('searchLabel.endpointType'),
        endpoint: this.$t('searchLabel.endpoint'),
        noData: this.$t('message.nodata'),
        vpnGatewayName: this.$t('searchLabel.vpnGatewayName'),
        localTunnelIp: this.$t('searchLabel.localTunnelIp'),
        peerTunnelIp: this.$t('searchLabel.peerTunnelIp'),
        peerVpnGatewayIp: this.$t('searchLabel.peerVpnGatewayIp'),
        remoteSubnet: this.$t('searchLabel.remoteSubnet'),
        nodeType: this.$t('searchLabel.nodeType'),
        serviceRepl: this.$t('searchLabel.serviceRepl'),
        webRepl: this.$t('searchLabel.webRepl'),
        queryEngineType: this.$t('searchLabel.queryEngineType'),
        autoscaling: this.$t('searchLabel.autoscaling'),
        maxQuery: this.$t('searchLabel.maxQuery'),
        clusSize: this.$t('searchLabel.clusSize'),
        attachmentName: this.$t('searchLabel.attachmentName'),
        attachmentType: this.$t('searchLabel.attachmentType'),
        segmentName: this.$t('searchLabel.segmentName'),
        accessLocation: this.$t('searchLabel.accessLocation'),
        networkName: this.$t('searchLabel.networkNameDetail'),
        productState: this.$t('searchLabel.productState'),
        regionZone: this.$t('searchLabel.regionZone'),
        loadBalancer: this.$t('searchLabel.loadBalancer'),
        packetNoData: 'N/A',
        sparkTotalCore: this.$t('searchLabel.sparkTotalCore'),
        sparkTotalMemory: this.$t('searchLabel.sparkTotalMemory')
      },
      chartThemeColor: [
        '#20BAC2',
        '#6952DB',
        '#1E5FCB',
        '#0EBB59',
        '#FFC14A',
        '#D7C7FE',
        '#FD9C94',
        '#5C0931',
        '#8EDDCF',
        '#166440',
        '#E6E6E6',
        '#7394FF',
        '#8B21A6',
        '#BDBDBD',
        '#F56813',
        '#90DCE0',
        '#B4A9ED',
        '#808DAE',
        '#87DDAC',
        '#FFE0A5'
      ]
    };
  },
  methods: {
    getColorOfChart(numberLine) {
      let lstColor = [];

      for (let i = 0; i < numberLine; i++) {
        let color = '#' + ((Math.random() * 0xffffff) << 0).toString(16).padStart(6, '0');
        lstColor.push(color);
      }

      return lstColor;
    },
    async apiGetTags(productResourceId, productTypeCode, isAsg = false) {
      return await this.$http.system.get(
        `/v1/console/products/` +
        encodeURIComponent(productResourceId) +
        `/tags?asgYn=${isAsg ? 'Y' : 'N'}`,
        {},
        true,
        false,
        { headers: { 'X-ResourceType': productTypeCode } }
      );
    },

    async apiGetMainMetrics(params, productTypeCode) {
      return await this.$http.product.get('/v1/console/main-metrics', params, true, false, {
        headers: { 'X-ResourceType': productTypeCode }
      });
    },

    async apiGetMetricData(params, productTypeCode, handledAuthError = false) {
      let propertyHeaders = { 'X-ResourceType': productTypeCode };

      return await this.$http.product.post('/v1/console/metric-data', params, true, false, {
        headers: propertyHeaders
      }, false, [], { handledAuthError });
    },

    async apiGetEventPolicies(policyId, productTypeCode) {
      return await this.$http.event.get(`/v1/console/event-policies/${policyId}`, {}, true, false, {
        headers: { 'X-ResourceType': productTypeCode }
      });
    },

    async apiGetEventNotify(params, productTypeCode, handledAuthError = false) {
      return await this.$http.event.get(
        `/v1/console/events/${params.eventId}/notification-states`,
        params,
        true,
        false,
        { headers: { 'X-ResourceType': productTypeCode } },
        false, 
        [], 
        { handledAuthError }
      );
    },

    async apiGetProductEvents(params, productResourceId, productTypeCode, handledAuthError = false) {
      let propertyHeaders = { 'X-ResourceType': productTypeCode };

      return await this.$http.event.get(
        `/v1/console/products/${productResourceId}/events`,
        params,
        true,
        false,
        { headers: propertyHeaders },
        false, 
        [], 
        { handledAuthError }
      );
    },

    async apiPostEventPolicies(params, productTypeCode) {
      return await this.$http.event.post('/v1/console/event-policies', params, true, false, {
        headers: { 'X-ResourceType': productTypeCode }
      });
    },

    async apiGetLogs(params, productTypeCode, handledAuthError = false) {
      return await this.$http.log.get('/v1/console/logs', params, true, false, {
        headers: { 'X-ResourceType': productTypeCode }
      }, false, [], { handledAuthError });
    },

    async apiGetLogUsages(params, productTypeCode, handledAuthError = false) {
      return await this.$http.log.get('/v1/console/log-data/log-usage', params, true, false, {
        headers: { 'X-ResourceType': productTypeCode }
      }, false, [], { handledAuthError });
    }
  }
};
export default monTargetMixin;
